import React, { useEffect, useState } from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import BaseModal from '../../../../components/modals/BaseModal';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';

function EnterGroupModal({ show, onHide, groups, handleEnterGroup }) {
  const [selectedGroup, setSelectedGroup] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (groups && groups.length > 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setSelectedGroup(groups[0]);
    }
  }, [groups]);

  const handleSelectChange = (event) => {
    setSelectedGroup(event.target.value);
  };

  const handleConfirm = () => {
    if (selectedGroup) {
      handleEnterGroup(selectedGroup);
    }
    onHide();
  };

  return (
    <BaseModal
      open={show}
      onClose={onHide}
      title={t(StringKeys.ENTER_GROUP)}
      onSubmit={handleConfirm}
      submitButtonText={t(StringKeys.ENTER)}
      size="sm"
      enableEnterKey={true}
    >
      <FormControl fullWidth>
        <Select
          value={selectedGroup}
          onChange={handleSelectChange}
          displayEmpty
        >
          {groups &&
            groups.map((group, index) => (
              <MenuItem key={index} value={group}>
                {group}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </BaseModal>
  );
}

export default EnterGroupModal;
